import { borrowerNavigation } from "./configs/borrowerNavigation";
import { lenderNavigation } from "./configs/lenderNavigation";
import { adminNavigation } from "./configs/adminNavigation";
import { vendorNavigation } from "./configs/vendorNavigation";
import { routeConfig } from "./configs/routeConfig";

export const navigation = {
  borrower: borrowerNavigation,
  lender: lenderNavigation,
  admin: adminNavigation,
  vendor: vendorNavigation,
};

export { routeConfig };